import type { PointerEvent as ReactPointerEvent } from 'react'

import { cn } from '@/utils'

interface ColumnResizeHandleProps {
  onResizeStart: (event: ReactPointerEvent<HTMLElement>) => void
  isResizing?: boolean
}

export const ColumnResizeHandle = ({
  onResizeStart,
  isResizing = false,
}: ColumnResizeHandleProps) => (
  <div
    aria-hidden="true"
    onPointerDown={onResizeStart}
    onClick={(event) => event.stopPropagation()}
    // Sits inside the cell instead of straddling its edge: an overhanging
    // handle on the last column widens the table and adds a stray scrollbar.
    className={cn(
      'absolute right-0 top-0 z-10 h-full w-2 cursor-col-resize touch-none select-none',
      'after:absolute after:inset-y-0 after:right-0 after:w-px after:transition-colors',
      isResizing ? 'after:w-0.5 after:bg-brand' : 'after:hover:bg-border',
    )}
  />
)
